export default {
  "role.name": "権限名",
  "role.create": "権限を作成",
  "role.update": "権限を更新",
  "role.permission": "権限内容",
  "role.admin": "管理者権限",
  "role.section": "セクション",
  "role.plsEnterRoleName": "権限名を入力してください",
};